/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_d60dd6a8"]'><div><cube-button @_click="showPickerWithSetTime">Use setTime</cube-button><cube-time-picker-popup title="时间选择器" ref="__mpx_ref_picker__"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_d60dd6a8"}'>
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d60dd6a8"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d60dd6a8"}
  /** script content **/
  require("./set-time-picker.mpx.js?isComponent&outputPath=components%2Fset-time-pickerd60dd6a8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./set-time-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fset-time-pickerd60dd6a8%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d60dd6a8"],
    ctorType: "component",
    outputPath: "components/set-time-pickerd60dd6a8/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-time-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker-popup/index.mpx?isComponent&outputPath=components%2Findex07b2fcda%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>